
import Vue from 'vue';
import Component from 'vue-class-component';
import TCheckbox from '@/lib/form/checkbox/Checkbox.vue';
import apiClient from '@/app/clients/api-client';
import { Watch, Inject } from 'vue-property-decorator';
import TButton from '@/lib/form/button/Button.vue';
import ListView from '@/app/components/folder/ListView.vue';
import SearchVideos from '@/app/components/SearchVideos.vue';
import UploadVideoComponent from "@/app/components/UploadVideoComponent.vue";

@Component({
  name: 'select-videos',
  props: {
    actionText: { required: false },
    customHeader: { required: false },
    'single-select': { required: false },
    uid: { required: false, default: '' },
    toBeExcluded: {
      required: false,
      default() {
        return [];
      },
    },
    loadingVideos: {
      required: false,
      default() {
        return [];
      },
    },
    v2Only: {
      required: false,
      default: false,
    },
  },
  components: {
    UploadVideoComponent,
    TCheckbox,
    TButton,
    ListView,
    SearchVideos,
  },
})
export default class SelectVideosModal extends Vue {
  private loading = false;
  private toBeExcluded;
  private excludedVideosFromParams: any[] = [];
  private selectedVideos: any[] = [];
  private loadedFolders = {};
  private loadedVideos = {};
  private singleSelect;
  private folderId = this.$user.state.workspace.rootFolderId;
  private tab = 'videos';
  private headerTitle = '';
  private inputLabel = '';
  private inputPlaceholder = '';
  private canCollectTitle = true;
  private canShowUpload = true;
  private payload: any = null;

  get toBeExcludedVideos() {
    return [...this.excludedVideosFromParams, ...this.toBeExcluded];
  }
  beforeOpen(e) {
    this.excludedVideosFromParams = (e.params && e.params.toBeExcluded) || [];
    this.headerTitle = e.params && e.params.headerTitle || '';
    this.inputLabel = e.params && e.params.inputLabel || '';
    this.inputPlaceholder = e.params && e.params.inputPlaceholder || '';
    this.canCollectTitle = (e.params && e.params.hasOwnProperty('canCollectTitle')) ? e.params.canCollectTitle : true;
    this.canShowUpload = (e.params && e.params.hasOwnProperty('canShowUpload')) ? e.params.canShowUpload : true;
    this.payload = e.params && e.params.payload || null;
  }

  mounted() {
    this.$root.$on('update-loaded-folders', this.updateLoadedFolders);
  }

  close() {
    document.body.click();
  }

  update(checked, value) {
    if (this.singleSelect) {
      this.selectedVideos = [];
      this.selectedVideos.push(value);
      return;
    }
    if (checked) {
      this.selectedVideos.push(value);
    } else {
      const index = this.selectedVideos.indexOf(value);
      index != -1 && this.selectedVideos.splice(index, 1);
    }
  }

  updateLoadedFolders(folderId, folders, videos) {
    this.folderId = folderId;
    if (folders && videos) {
      this.loadedFolders[folderId] = folders;
      this.loadedVideos[folderId] = videos;
    }
  }

  add() {
    if (this.singleSelect) {
      this.$emit('selectedVideos', this.selectedVideos[0]);
    } else {
      this.$emit('selectedVideos', this.selectedVideos, this.payload);
    }
  }

  addUploadVideo(videoId) {
    if(this.singleSelect) {
      this.$emit('selectedVideos', videoId);
    } else {
      this.$emit('selectedVideos', [videoId], this.payload);
    }
  }
  
  setTab(tab) {
    this.tab = tab;
  }

  resetData() {
    this.loading = false;
    this.selectedVideos = [];
    this.excludedVideosFromParams = [];
    this.loadedFolders = {};
    this.loadedVideos = {};
    this.folderId = this.$user.state.workspace.rootFolderId;
  }
}
